import { IIconProps } from 'src/interfaces/Icon';

const SettingsIconSmall = ({ width = 14, height = 12, color = '#fff', ...props }: IIconProps) => (
  <svg
    data-testid='settings-icon-small'
    width={width}
    height={height}
    viewBox='0 0 14 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M11.3468 0.8445L13.7156 5.07979C14.0948 5.6447 14.0948 6.3553 13.7156 6.92021L11.3468 11.1555C10.9948 11.6801 10.3683 12 9.69309 12H4.30691C3.63174 12 3.00523 11.6801 2.65316 11.1555L0.284356 6.92021C-0.0947855 6.3553 -0.0947852 5.6447 0.284356 5.07979L2.65316 0.8445C3.00523 0.319932 3.63174 0 4.30691 0H9.69309C10.3683 0 10.9948 0.319933 11.3468 0.8445ZM12.8429 6.43207L10.4981 10.6244C10.3411 10.8377 10.0478 11 9.69309 11H4.30691C3.95218 11 3.65886 10.8377 3.5019 10.6244L1.15712 6.43207L1.1373 6.39663L1.11468 6.36293C0.961773 6.1351 0.961773 5.8649 1.11468 5.63707L1.1373 5.60337L1.15712 5.56793L3.5019 1.37559C3.65886 1.16234 3.95218 1 4.30691 1H9.69309C10.0478 1 10.3411 1.16234 10.4981 1.37559L12.8429 5.56793L12.8627 5.60337L12.8853 5.63708C13.0382 5.8649 13.0382 6.1351 12.8853 6.36293L12.8627 6.39664L12.8429 6.43207ZM5.5 6C5.5 5.17157 6.17157 4.5 7 4.5C7.82843 4.5 8.5 5.17157 8.5 6C8.5 6.82843 7.82843 7.5 7 7.5C6.17157 7.5 5.5 6.82843 5.5 6ZM7 3.5C5.61929 3.5 4.5 4.61929 4.5 6C4.5 7.38071 5.61929 8.5 7 8.5C8.38071 8.5 9.5 7.38071 9.5 6C9.5 4.61929 8.38071 3.5 7 3.5Z'
      fill={color}
    />
  </svg>
);

export default SettingsIconSmall;
